import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ReverseInvoiceEffects } from './effects/reverse-invoice.effects';
import { reverseInvoiceFeatureKey, reverseInvoiceReducer } from './reverse-invoice-reducer';
import { EnvironmentProviders } from '@angular/core';

export const provideReverseInvoiceStore = (): EnvironmentProviders[] => [
    provideState(reverseInvoiceFeatureKey, reverseInvoiceReducer),
    provideEffects(ReverseInvoiceEffects)
];
